/** @module Camunda/TaskUserResponseRenderer */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/heading/String",
	"csi/locale"
], function(declare,_,StringRen,locale) {

	return declare(StringRen, {
		/**
		 * @override
		 * Do not allow filtering/sorting
		 */
		getQuerySpec: function(ctx, h, spec) {
			return null;
		},
		
		/**
		 * @override
		 * Get localized name from action
		 */
		_getValue: function(ctx, h) {
			var value = this.inherited(arguments);
			if (value) {
				const cache = ctx.cache;
				const task = ctx.getNode();
				const taskDefinition = cache.get(task.TaskDefinition);
				const actionGroup = cache.get(taskDefinition.ActionGroup);
				const actions = cache.getNodes(actionGroup.Actions);
				const action = _.findWhere(actions, {$Name: value});
				return locale.getNodeName(action, cache);
			}
			
			return value;
		}
	});
});
